import styled from 'styled-components';

var ConceptRow = styled.div.withConfig({
  displayName: "ConceptRowstyle__ConceptRow",
  componentId: "sc-oud7xh-0"
})(["align-items:center;background:var(--color-background-surface-secondary);color:var(--color-text);display:flex;font:var(--font-headline-xs);padding:var(--space-200) 10px;"]);

export { ConceptRow };
//# sourceMappingURL=ConceptRow.style.js.map
